import { render, staticRenderFns } from "./NotificationPanelList.vue?vue&type=template&id=a57e2a34&"
import script from "./NotificationPanelList.vue?vue&type=script&lang=js&"
export * from "./NotificationPanelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports